/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataPopupConfigInfoRespVo } from './PageDataPopupConfigInfoRespVo';
import {
    PageDataPopupConfigInfoRespVoFromJSON,
    PageDataPopupConfigInfoRespVoFromJSONTyped,
    PageDataPopupConfigInfoRespVoToJSON,
    PageDataPopupConfigInfoRespVoToJSONTyped,
} from './PageDataPopupConfigInfoRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataPopupConfigInfoRespVo
 */
export interface ResponsePageDataPopupConfigInfoRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataPopupConfigInfoRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataPopupConfigInfoRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataPopupConfigInfoRespVo}
     * @memberof ResponsePageDataPopupConfigInfoRespVo
     */
    data?: PageDataPopupConfigInfoRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataPopupConfigInfoRespVo interface.
 */
export function instanceOfResponsePageDataPopupConfigInfoRespVo(value: object): value is ResponsePageDataPopupConfigInfoRespVo {
    return true;
}

export function ResponsePageDataPopupConfigInfoRespVoFromJSON(json: any): ResponsePageDataPopupConfigInfoRespVo {
    return ResponsePageDataPopupConfigInfoRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataPopupConfigInfoRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataPopupConfigInfoRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataPopupConfigInfoRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataPopupConfigInfoRespVoToJSON(json: any): ResponsePageDataPopupConfigInfoRespVo {
    return ResponsePageDataPopupConfigInfoRespVoToJSONTyped(json, false);
}

export function ResponsePageDataPopupConfigInfoRespVoToJSONTyped(value?: ResponsePageDataPopupConfigInfoRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataPopupConfigInfoRespVoToJSON(value['data']),
    };
}

